import {
  drawerWidth,
  transition,
  boxShadow,
  defaultFont,
  primaryColor,
  primaryDarkColor,
  fontSize,
  sidebarBgColor,
  textPrimaryColor,
  textMutedColor,
  borderSubtleColor,
} from 'assets/jss/material-dashboard-react';

const sidebarStyle = theme => ({
  drawerPaper: {
    background: sidebarBgColor,
    border: 'none',
    borderLeft: `1px solid ${borderSubtleColor}`,
    position: 'fixed',
    top: '0',
    bottom: '0',
    left: '0',
    zIndex: '1',
    ...boxShadow,
    width: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      position: 'fixed',
      height: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: drawerWidth,
      ...boxShadow,
      position: 'fixed',
      display: 'block',
      top: '0',
      height: '100vh',
      right: '0',
      left: 'auto',
      zIndex: '1032',
      visibility: 'visible',
      overflowY: 'visible',
      borderTop: 'none',
      textAlign: 'left',
      paddingRight: '0px',
      paddingLeft: '0',
      transform: `translate3d(${drawerWidth}px, 0, 0)`,
      ...transition,
    },
  },
  brand: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    padding: '20px 16px 16px',
    position: 'relative',
    zIndex: 4,
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      right: 18,
      left: 18,
      height: 1,
      backgroundColor: borderSubtleColor,
    },
  },
  brandTextWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    minWidth: 0,
    flex: 1,
    gap: 8,
  },
  brandTitle: {
    ...defaultFont,
    margin: 0,
    fontSize: 12,
    fontWeight: 500,
    color: textPrimaryColor,
    lineHeight: 1.35,
  },
  brandSubtitle: {
    margin: 0,
    fontSize: 11,
    color: textMutedColor,
    lineHeight: 1.3,
  },
  logo: {
    position: 'relative',
    padding: '15px 15px',
    zIndex: '4',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: '0',
      height: '1px',
      right: '15px',
      width: 'calc(100% - 30px)',
      backgroundColor: borderSubtleColor,
    },
  },
  logoLink: {
    ...defaultFont,
    textTransform: 'none',
    padding: '5px 0',
    display: 'inline-block',
    fontSize: fontSize.m,
    textAlign: 'left',
    fontWeight: '500',
    lineHeight: '30px',
    textDecoration: 'none',
    backgroundColor: 'transparent',
    '&,&:hover': {
      color: primaryColor,
    },
  },
  logoImage: {
    width: '30px',
    display: 'inline-block',
    maxHeight: '30px',
    marginLeft: '10px',
    marginRight: '15px',
  },
  img: {
    width: '35px',
    top: '22px',
    position: 'absolute',
    verticalAlign: 'middle',
    border: '0',
  },
  background: {
    position: 'absolute',
    zIndex: '1',
    height: '100%',
    width: '100%',
    display: 'block',
    top: '0',
    left: '0',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    '&:after': {
      position: 'absolute',
      zIndex: '3',
      width: '100%',
      height: '100%',
      content: '""',
      display: 'block',
    },
  },
  list: {
    marginTop: '12px',
    paddingLeft: '0',
    paddingTop: '0',
    paddingBottom: '0',
    marginBottom: '0',
    listStyle: 'none',
    position: 'unset',
  },
  item: {
    position: 'relative',
    display: 'block',
    textDecoration: 'none',
    '&:hover,&:focus,&:visited,&': {
      color: textPrimaryColor,
    },
  },
  itemLink: {
    width: 'auto',
    margin: '4px 12px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 14px',
    backgroundColor: 'transparent',
    fontSize: fontSize.m,
    borderRadius: 10,
    transition: 'background-color 0.2s ease, color 0.2s ease',
    '&.active': {
      backgroundColor: 'rgba(0, 168, 188, 0.1)',
      boxShadow: `inset -3px 0 0 ${primaryColor}`,
    },
    '&.active $itemText, &.active $itemIcon, &.active $itemIcon svg': {
      color: primaryDarkColor,
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 168, 188, 0.06)',
    },
    ...defaultFont,
  },
  itemIcon: {
    width: '24px',
    height: '30px',
    float: 'left',
    marginRight: '12px',
    marginLeft: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
    color: textMutedColor,
    minWidth: 24,
  },
  itemText: {
    ...defaultFont,
    margin: '0',
    padding: 0,
    lineHeight: '1.35',
    fontSize: 13,
    fontWeight: 400,
    color: textMutedColor,
  },
  switchRow: {
    margin: '8px 12px 0',
    padding: '8px 10px',
    borderRadius: 10,
    backgroundColor: 'rgba(0, 168, 188, 0.04)',
    border: `1px solid ${borderSubtleColor}`,
  },
  sidebarWrapper: {
    position: 'relative',
    height: 'calc(100vh - 92px)',
    overflow: 'auto',
    zIndex: '4',
    overflowScrolling: 'touch',
    paddingBottom: 16,
  },
  activePro: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      width: '100%',
      bottom: '13px',
    },
  },
});

export default sidebarStyle;
